import React, { useState, useEffect, useRef, useContext } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Container, Card, Button, Form, Badge } from "react-bootstrap";
import SimpleBanner from "../general/SimpleBanner";
import Navbar from "../../../components/user/navbar/Navbar";
import Footer from "../footer/Footer";
import AppContext from "../../../context/AppContext";
import axios from "axios";

const SupportInCustomer = () => {

    const { baseUrl } = useContext(AppContext);
    const { OrderId } = useParams();
    const[orderId,setorderId]= useState();
    const[customerId,setcustomerId]=useState();
    const location = useLocation();
    const navigate = useNavigate();
    const openOrderDispute = () => {
        const formData = new FormData();
        formData.append("customer_id", customerId); 
        formData.append("type", "order");
        formData.append("order_id", orderId);
        formData.append("title", "order dispute");
        console.log(formData);
        axios
            .post(`${baseUrl}/general/Tpchat/viewAllOrders`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            })
            .then((response) => {
                console.log(response.data);
            })
            .catch((error) => {
                console.log(error);
            
            });
    };

    // Ticket subject passed via state from SupportInSeller
    const ticketSubject = location.state?.subject || "No Subject";

    // Mock messages
    const [messages, setMessages] = useState([
        { id: 1, sender: "user", text: "Hello, I need help with my order" },
        { id: 2, sender: "seller", text: "Sure! Can you share your order ID?" },


        { id: 1, sender: "user", text: "Hello, I need help with my order   I need help with my order   I need help with my order  I need help with my order" },
        { id: 2, sender: "seller", text: "Sure! Can you share your order ID? Can you share your order ID? Can you share your order ID? Can you share your order ID?" },

        { id: 1, sender: "user", text: "Hello, I need help with my order" },
        { id: 2, sender: "seller", text: "Sure! Can you share your order ID?" },
    ]);

    const [newMessage, setNewMessage] = useState("");
    const messagesEndRef = useRef(null);
    

    // Scroll to bottom on new messages
    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    const handleSendMessage = () => {
        if (newMessage.trim() === "") return;
        setMessages([
            ...messages,
            { id: Date.now(), sender: "seller", text: newMessage },
        ]);
        setNewMessage("");
    };
     useEffect(() => {
        openOrderDispute();
      }, []);


    return (
        <Container fluid className="py-4 px-0">
            <Navbar />

            <SimpleBanner
                title="Support"
                subtitle=""
                breadcrumbs={[
                    { label: "Home", href: "/" },
                    { label: "support", href: "/customer-supports" },
                ]}
            />





            <Card className="chat-card">
                {/* Header */}
                <Card.Header className="chat-header d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center">
                        <h5 className="mb-0">Support: {OrderId}</h5>
                        <Badge bg="info">{ticketSubject}</Badge>
                    </div>
                    <small className="text-muted">Support Chat</small>
                </Card.Header>

                {/* Messages */}
                <Card.Body className="chat-body">
                    {messages.map((msg) => (
                        <Card
                            key={msg.id}
                            className={`chat-message ${msg.sender === "user" ? "from-user" : "from-seller"
                                } mb-2`}
                        >
                            <Card.Body className="p-2">{msg.text}</Card.Body>
                        </Card>
                    ))}
                    <div ref={messagesEndRef} />
                </Card.Body>

                {/* Input */}
                <Card.Footer className="chat-input d-flex">
                    <Form.Control
                        type="text"
                        placeholder="Type your message..."
                        value={newMessage}
                        onChange={(e) => setNewMessage(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && handleSendMessage()}
                    />
                    <Button className="ms-2" onClick={handleSendMessage}>
                        Send
                    </Button>
                </Card.Footer>
                <Button
                    variant="secondary"
                    className="mb-3"
                    onClick={() => navigate("/customer-orders")}
                >
                    Back to Orders
                </Button>
            </Card>

            <Footer />
        </Container>

    );
};

export default SupportInCustomer;